import React from "react"
import PropTypes from "prop-types"

import TopicTags from './TopicTags'
import SearchBar from './SearchBar'
import TopicSelector from './TopicSelector'
import TopicElement from './TopicElement'
import Icon from '../app_components/Icon'

class TopicsContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      selectedTab: '',
      selectedTags: [],
      allTopics: '',
      myTopics: '',
      savedTopics: '',
      savedTopicsIds: [],
      tags: [],
      searchText: ''
    }

    this.onSelectTab = this.onSelectTab.bind(this)
    this.updateSelectedTags = this.updateSelectedTags.bind(this)
    this.getAllTopics = this.getAllTopics.bind(this)
    this.showTopics = this.showTopics.bind(this)
    this.getTopicsApiCall = this.getTopicsApiCall.bind(this)
    this.unfavoriteTopic = this.unfavoriteTopic.bind(this)
    this.favoriteTopic = this.favoriteTopic.bind(this)
    this.searchTopics = this.searchTopics.bind(this)
    this.updateSearchText = this.updateSearchText.bind(this)
    this.topicList = this.topicList.bind(this)
  }

  getAllTopics() {
    $.ajax({
      url: `../get_all_exchanges`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          allTopics: JSON.parse(data.data.exchanges),
          savedTopicsIds: JSON.parse(data.data.favorite_exchanges),
          tags: JSON.parse(data.data.tags)
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  updateSearchText(text) {
    this.setState({
      searchText: text
    }, () => this.searchTopics())
  }

  searchTopics() {
    $.ajax({
      url: `../search_exchanges`,
      dataType: 'JSON',
      type: 'GET',
      data: {
        searchText: this.state.searchText,
        tags: this.state.selectedTags
      },
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          allTopics: JSON.parse(data.data.exchanges),
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  getMyTopics() {
    $.ajax({
      url: `../get_my_exchanges`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          myTopics: JSON.parse(data.data.exchanges),
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  getFavTopics() {
    $.ajax({
      url: `../get_favorite_exchanges`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          savedTopics: JSON.parse(data.data.exchanges),
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  getTopicsApiCall() {
    if(this.state.selectedTab === 3) {
      this.getAllTopics()
    } else if (this.state.selectedTab === 2) {
      this.getMyTopics()
    } else if (this.state.selectedTab === 1) {
      this.getFavTopics()
    }
  }


  componentWillMount() {
    if(this.state.selectedTab === '') {
      this.setState({
        selectedTab: 3
      }, () => this.getTopicsApiCall())
    }

    if(this.state.selectedTags.length === 0) {
      this.setState({
          selectedTags: [1,2,3,4]
      })
    }

    if(this.props.meetingId != undefined) {
      this.setState({ meetingId: this.props.meeting_id})
    }
  }

  updateSelectedTags(n) {
    if(this.state.selectedTags.includes(n)) {
      let newSelectedLevels = this.state.selectedTags.filter(function(e) { return e !== n })
      this.setState({
        selectedTags: newSelectedLevels
      }, () => this.searchTopics())
    } else {
      let selectedTags = this.state.selectedTags
      let newSelectedLevels = selectedTags.concat(n)
      this.setState({
        selectedTags: newSelectedLevels
      }, () => this.searchTopics())
    }
  }

  onSelectTab(n) {
    this.setState({
      selectedTab: n
    }, () => this.getTopicsApiCall())

  }

  unfavoriteTopic(id) {
    let array = this.state.savedTopicsIds
    let index = array.indexOf(id);
    let newArray = array.splice(index)
    this.setState({
      selected: newArray
    })
  }



  favoriteTopic(id) {
    let array = this.state.savedTopicsIds
    array.push(id)
    this.setState({
      selected: array
    })
  }

  topicList(array) {
    let topicsList = array.map((topic, index) => {
      return(<TopicElement
        unfavoriteTopic={this.unfavoriteTopic}
        favoriteTopic={this.favoriteTopic}
        selectedTags={this.state.savedTopicsIds}
        topic={topic}
        key={topic.id}
        index={topic.id}
        favoriteStarLottie={this.props.favoriteStarLottie}
        meetingId={this.props.meetingId}
        />)
    })
    return topicsList
  }

  showTopics() {
    if(this.state.selectedTab === 3) {
      if(this.state.allTopics != '') {
        return this.topicList(this.state.allTopics)
      }
      return null
    } else if (this.state.selectedTab === 2) {
      if(this.state.myTopics.length > 0) {
        return this.topicList(this.state.myTopics)
      }
      return <p className="exchangesPage__empty">You have not created any activities yet.</p>

    } else if (this.state.selectedTab === 1) {
      if(this.state.savedTopics.length === 0) {
        return <p className="exchangesPage__empty">No saved activities yet. Search and tap the star to save topics.</p>
      }
        return this.topicList(this.state.savedTopics)
    }
  }

  newButton() {
    return(
      <div className="exchangesPage__newBtnWrap">
        <button
          type="button"
          className="exchangesPage__newBtn"
          onClick={() => window.location.assign("/new_topic")}
        >
          + New
        </button>
      </div>
    )
  }

  render() {
    const isEmbedded = this.props.meetingId != undefined

    return(
      <div className={`exchangesPage${isEmbedded ? ' exchangesPage--embedded' : ''}`}>
        {!isEmbedded &&
          <header className="exchangesPage__header">
            <span className="exchangesPage__iconCircle" aria-hidden="true">
              <Icon name="rocket" size={20} color="#494CE9" />
            </span>
            <h1 className="exchangesPage__title">Activities</h1>
          </header>
        }
        {!isEmbedded &&
          <div className="exchangesPage__gameLinks">
            <a className="exchangesPage__gameLink exchangesPage__gameLink--play" href="/games">🎮 Play a game</a>
            <a className="exchangesPage__gameLink" href="/games?join=1">🎟️ Join with a code</a>
          </div>
        }

        <div className="exchangesPage__controls topics_container">
          <TopicSelector selectedTab={this.state.selectedTab} onSelectTab={this.onSelectTab}/>
          {this.state.selectedTab === 3 && <SearchBar updateSearchText={this.updateSearchText} searchText={this.state.searchText} searchTopics={this.searchTopics} searchLottie={this.props.searchLottie} />}
          {this.state.selectedTab === 3 && <TopicTags tags={this.state.tags} selectedTags={this.state.selectedTags} updateSelectedTags={this.updateSelectedTags}/>}
          {this.state.selectedTab === 2 && this.newButton()}
        </div>

        <div className="exchangesPage__grid">
          {this.showTopics()}
        </div>
      </div>
    )
  }

}

export default TopicsContainer;
